
import Vue from 'vue';
import { Component, Emit, Prop, Model } from 'vue-property-decorator';
import { tUi } from '@/utils/translate';

@Component({
  name: 'RepsolDialogOkComponent'
})
export default class RepsolDialogOkComponent extends Vue {

  @Model()
  public dialogOk!: boolean;

  @Prop()
  public readonly item!: any;

  @Prop()
  public readonly textOk!: string;
  @Prop()
  public readonly title!: string;
  @Prop()
  public readonly subtitle!: string;

  translate(value: string, params?: Record<string, unknown>): string {
    return tUi(value, params);
  }

  @Emit()
  ok() {
    return this.item;
  }
}
Vue.component('repsol-dialog-ok', RepsolDialogOkComponent);
